import React, { useContext } from 'react'
import { Dropdown } from 'components/common/dropdown'
import type { SelectItem } from 'components/common/dropdown'
import { FormContext } from './FormContext'
import { VehicleSelectItemShape } from './VehicleSelectItemShape'

type GeneralSelectItems = SelectItem[] | VehicleSelectItemShape[]
const addBlankOption = (options: GeneralSelectItems): GeneralSelectItems => [{ id: '', name: '' }, ...options]

const contractsFromVehicleId = (vehicleId: string, vehicleOptions: VehicleSelectItemShape[]): SelectItem[] => {
  const vehicleOptionFromId = vehicleOptions.find(vehicleOption => vehicleId === vehicleOption.id)
  return vehicleOptionFromId?.contracts ?? []
}

/**
 * How it works
 * The vehicleId from Context will filter the contractOptions
 * It is up to the change handlers to update the context to the new vehicleId to display contracts from that new vehicle
 * A change in vehicleId will re-render with the updated contract options.
 */
export const ContractAndVehicleSelectForm: React.FC = () => {
  const { vehicleId, handleVehicleChange, handleContractChange, selectOptions } = useContext(FormContext)

  const contractOptions = addBlankOption(contractsFromVehicleId(vehicleId, selectOptions))

  return (
    <form id='supplier-onboarding-contract-vehicle-form'>
      <Dropdown label='Select Contract Vehicle' id='supplier_contract_vehicles' items={selectOptions} onChange={handleVehicleChange} />
      <Dropdown label='Select Contract' id='supplier_contracts' items={contractOptions} onChange={handleContractChange} key={vehicleId} />
    </form>
  )
}
